import { Input, Select } from "@clintonelec/react-storybook";
import { snmpAuthProtocolOptions, snmpPrivacyProtocolOptions } from "Data/Objects/Network";
import { produce } from "immer";
import { type SnmpSettingsState, SnmpAuthenticationProtocol, SnmpPrivacyProtocol } from "Interfaces";
import { Fragment, memo } from "react";

const authenticationKeyRegex = new RegExp(/^.{8,128}$/);

type SnmpV3Props = {
	formSubmitted: boolean;
	localSnmpSettings: SnmpSettingsState;
	setSnmpSettings: (snmpSettings: SnmpSettingsState) => void;
};

function SnmpV3Options(props: SnmpV3Props) {
	const { formSubmitted, localSnmpSettings, setSnmpSettings } = props;

	const handleAuthProtocolSelect = (newProtocol: string | null) => {
		if (!newProtocol) {
			return;
		}

		const newLocalState = produce(localSnmpSettings, draft => {
			draft.v3.authProtocol = newProtocol as SnmpAuthenticationProtocol;
		});

		setSnmpSettings(newLocalState);
	};

	const handlePrivacyProtocolSelect = (newProtocol: string | null) => {
		if (!newProtocol) {
			return;
		}

		const newLocalState = produce(localSnmpSettings, draft => {
			draft.v3.privacyProtocol = newProtocol as SnmpPrivacyProtocol;
		});

		setSnmpSettings(newLocalState);
	};

	return (
		<Fragment>
			<div className="form-row space">
				<span>User Name</span>
				<Input
					name="username"
					value={ localSnmpSettings.v3.username }
					wrapClassName="form-input"
				/>
			</div>
			<div className="form-row">
				<span>Authentication Protocol</span>
				<Select
					allowClear={ false }
					className="form-select"
					onSelect={ handleAuthProtocolSelect }
					options={ snmpAuthProtocolOptions }
					value={ localSnmpSettings.v3.authProtocol }
				/>
			</div>
			<div className="form-row">
				<span>Authentication Password</span>
				<Input
					disabled={ localSnmpSettings.v3.authProtocol === SnmpAuthenticationProtocol.NONE }
					name="authPassword"
					noValidate={ !formSubmitted }
					required={ localSnmpSettings.v3.authProtocol !== SnmpAuthenticationProtocol.NONE }
					validator={ authenticationKeyRegex }
					validityMessage="The password must be between 8 and 128 characters."
					value={ localSnmpSettings.v3.authPassword }
					wrapClassName="form-input"
				/>
			</div>
			<div className="form-row">
				<span>Privacy Protocol</span>
				<Select
					allowClear={ false }
					className="form-select"
					onSelect={ handlePrivacyProtocolSelect }
					options={ snmpPrivacyProtocolOptions }
					value={ localSnmpSettings.v3.privacyProtocol }
				/>
			</div>
			<div className="form-row">
				<span>Privacy Password</span>
				<Input
					disabled={ localSnmpSettings.v3.privacyProtocol === SnmpPrivacyProtocol.NONE }
					name="privacyPassword"
					validator={ authenticationKeyRegex }
					validityMessage="The password must be between 8 and 128 characters."
					required={ localSnmpSettings.v3.privacyProtocol !== SnmpPrivacyProtocol.NONE }
					value={ localSnmpSettings.v3.privacyPassword }
					wrapClassName="form-input"
				/>
			</div>
		</Fragment>
	);
}

export default memo(SnmpV3Options);
